import { Box } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { Show, SimpleShowLayout } from "react-admin";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import CourseInfo from "./CourseInfo";

const ShowGoogleCourses = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const shadow = isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox;

  return (
    <Show
      title="Детайли за Google Зала"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          paddingY={2}
          title="Информация"
          textAlign="center"
        />
        <Box sx={shadow}>
          <CourseInfo />
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowGoogleCourses;
